import React, { useState, useRef, useEffect } from "react";
import { useWallManager } from "../hooks/useWallManager";
import { useWindowSize } from "../hooks/useWindowSize";

export const BricksCanvas: React.FC = () => {
  const wallManager = useWallManager();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const size = useWindowSize();
  const [canvasWidth, setCanvasWidth] = useState(100);
  const [canvasHeight, setCanvasHeight] = useState(100);

  useEffect(() => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext("2d");
      if (ctx) {
        wallManager.setContext(ctx);
        const { height, width } = canvasRef.current.getBoundingClientRect();
        wallManager.setSize(height, width);
        setCanvasHeight(height);
        setCanvasWidth(width);
        wallManager.startDrawing();
      }
    }
  }, [canvasRef, wallManager.setContext, wallManager.setSize, wallManager.startDrawing, size]);

  return (
    <canvas
      style={{ width: "100%", height: "calc(100% - 48px)" }}
      width={canvasWidth}
      height={canvasHeight}
      ref={canvasRef}
    />
  );
};
